import React from "react";
import {OrderEditorTabProps} from "@widgets/pos/order/OrderEditor";
import LoadingScreen from "@widgets/pos/layout/LoadingScreen";
import useMenu from "@widgets/pos/order/hooks/MenuProvider";
import CategoriesList from "@widgets/pos/order/menu/categories/CategoriesList";
import ProductsPage from "@widgets/pos/order/menu/products/ProductsPage";
import {AvailableCategory} from "@/data/entities/menu";


const MenuOverview = (tabProps: OrderEditorTabProps) => {
    const {menuLoading, availableMenu} = useMenu();

    if (menuLoading) {
        return <LoadingScreen/>;
    }

    return (
        <div className={"h-full max-h-full grid grid-cols-[300px_1fr]"}>
            <div className={"p-6 sticky top-0"}>
                <CategoriesList {...tabProps} />
            </div>

            <section className={"max-h-full h-full overflow-y-auto p-6 flex flex-col gap-32"}>
                {
                    availableMenu.categories.map((category: AvailableCategory, i: number) =>
                        <ProductsPage
                            key={category.name}
                            categoryIndex={i}
                            category={category}
                            {...tabProps}
                        />
                    )
                }
            </section>
        </div>
    );
};

export default MenuOverview;